<template>
  <div class="qs-detail">
    <van-cell class="question">
      <div class="desc">{{store.langConfig['viewTask']}}</div>
      <div class="content">
        <div class="c-user">
          <div class="c-user-icon">
            <van-image  width="45" height="45" :src="require('../../assets/user.png')"></van-image>
          </div>
          <div class="c-user-info">
            <!-- <div class="user-name">{{chatInfo.roleName+' (ID:'+chatInfo.userId+')'}}</div> -->
            <div class="user-name">{{ 'ID:'+chatInfo.userId}}</div> 
            <div class="user-time">{{chatInfo.createTime}}</div>
          </div>
        </div>
        <div class="c-title">{{chatInfo.title}}</div>
      </div>
    </van-cell>
    <div class="chat-content">
      <van-list>
        <van-cell class="chat-item" v-for="(item,idx) in chatInfo.replies" :key="idx">
          <div class="t-name" :class="{'t-name-user': item.replyType===1, 't-name-customer': item.replyType===0}">{{item.replyType===0? store.langConfig['Customer']: (item.talker || store.langConfig['Player'])}}: </div>
          <div class="t-content">
            <div class="t-txt">{{item.replyContent}} <van-icon v-if="item.replyType===0" :name="require('../../assets/translate-icon.png')" size="20" @click="translateCustomerText(item, idx)" /></div>
            <div class="t-txt t-translate" v-if="item.translateText !== ''">{{ item.translateText }}</div>
            <div v-if="item.replyImagePath">
              <van-image v-for="path in item.replyImagePath.split('||')" :key="path" class="reply-img" :src="path"
                width="60" height="60" fit="contain" @click="scalePic([path])"></van-image>
            </div>
          </div>
          <div class="t-time">{{item.replyDate.split('.')[0]}}</div>
        </van-cell>
      </van-list>
    </div>
    <div class="qs-add" v-if="chatInfo.status !== 2">
      <div v-show="isUpload" class="add-img">
        <van-uploader ref="imgUploader" v-model="fileList" :max-size="10*1024*1024" :max-count="5" image-fit="contain" multiple  @oversize="onOversize"></van-uploader>
      </div>
      <div class="add-txt">
        <van-icon name="photo-o" size="25" @click.native="selectPics"></van-icon>
        <div class="box-input">
          <van-field v-model="inputValue" @input="changeInput"></van-field>
        </div>
        <div class="btn btn-send" @click="reply">{{store.langConfig['Send']}}</div>
        <div class="btn btn-solved" @click="closeQs">{{store.langConfig['Solved']}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {ImagePreview} from 'vant'
import { uploadImage, replyQuestion, getQuestionList, closeQuestion, getUserIp, translateCustomer, haveRead } from '@/api'
export default {
  name: 'QsDetail',
  props: {
    store: Object,
  },
  watch: {
    store: {
      deep: true,
      immediate:true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.newStoreInfo = newVal
        }
      }
    }
  },
  data(){
    return {
      inputValue: '',
      isUpload: false,
      fileList: [],
      chatInfo: {},
      lockApi: {
        image: false,
        question:false
      },
      userIp: '',
      newStoreInfo: ''
    }
  },
  activated(){
    this.getQuestionList()
    this.getIPAddress()
    this.userHaveRead()
  },
  methods: {
    // 禁用emoji
    changeInput(value){
      this.inputValue = value.replace(/(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]/g, '')
    },
    selectPics(){
      this.isUpload = !this.isUpload
      if (this.isUpload && this.fileList.length===0) {
        this.$refs.imgUploader.chooseFile()
      }
    },
    // 放大图片
    scalePic(path){
      ImagePreview(path)
    },
    // 获取问题列表
    getQuestionList(){
      let {appId, userId} = this.newStoreInfo.userInfo
      let params = {
        appId,
        userId,
        questionId: this.$route.query.questionId
      }
      getQuestionList(params).then(res => {
        this.chatInfo = res.data[0]
      })
    },
    // 回复
    reply(){
      if (this.fileList.length) {
        this.uploadImage()
      } else {
        this.addQs()
      }
    },
    onOversize(){
      this.$toast(this.newStoreInfo.langConfig['ImageOversize']);
    },
    uploadImage(){
      if (this.lockApi.image || this.lockApi.question) {
        this.$toast(this.newStoreInfo.langConfig['ImageLoading'])
        return false
      }

      let formData = new FormData()
      this.fileList.forEach(item => {
        formData.append('imageFiles', item.file)
      })
      formData.append('appId', this.newStoreInfo.userInfo.appId)
      this.lockApi.image = true
      this.newStoreInfo.loading = {
        isShow: true,
        showType: 2
      }
      uploadImage(formData).then(res=>{
        let imgPath = res.data.join('||')
        this.addQs(imgPath)
      }, ()=> {
        this.newStoreInfo.loading.isShow = false
      }).finally(()=>{
        this.lockApi.image = false
      })
    },
    addQs(path){
      if (this.lockApi.question) {
        this.$toast(this.newStoreInfo.langConfig['QuestionLoading'])
        return false
      }

      if (!path && !this.inputValue) {
        this.$toast(this.newStoreInfo.langConfig['InputEmpty'])
        return false
      }

      const {roleName} = this.newStoreInfo.userInfo
      let params = {
        questionId: this.$route.query.questionId,
        replyType: 1,
        talker: roleName,
        replyContent: this.inputValue,
        replyDate: this.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        replyImagePath: path?path:'' 
      }
      this.lockApi.question = true
      replyQuestion(params).then(()=>{
        this.fileList = []
        this.isUpload = false
        this.inputValue = ''

        this.getQuestionList()
      }).finally(()=>{
        this.lockApi.question = false
        this.newStoreInfo.loading = {
          isShow: false,
          showType: 2
        }
      })
    },
    closeQs(){
      closeQuestion({questionId: this.$route.query.questionId}).then(()=>{
        this.$router.push({path: '/customer/list', query: {type: 1}})
      })
    },
    translateCustomerText(data, idx) {
      translateCustomer({
        appId: this.newStoreInfo.userInfo.appId,
        content: data.replyContent,
        targetLanguage: this.newStoreInfo.userInfo.language,
        ip: this.userIp || ''
      }).then((res) => {
        this.chatInfo.replies.map((item, index) => {
          item.translateText = ''
          if (index === idx) {
            item.translateText = res.data
            this.$set(this.chatInfo.replies, idx, item)
          }
        })
      })
    },
    getIPAddress() {
      getUserIp().then((res) => {
        this.userIp = res.ip
      })
    },
    userHaveRead() {
      haveRead({
        questionId: this.$route.query.questionId
      }).then((res) => {
        console.log('33333', res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$mainColor: #599d00;

.qs-detail {
  position: relative;
  // height: 570px;
  .question {
    padding: 0;
    .desc {
      line-height: 20px;
      margin-bottom: 5px;
      color: #999;
      &::before {
        content: '';
        display: inline-block;
        width: 4px; height: 20px;
        background-color: $mainColor;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .content {
      background-color: $mainColor;
      padding: 10px;
      color: #fff;
      .c-user {
        display: flex;
        .c-user-icon {
          margin-right: 10px;
        }
        .c-user-info {
          .user-time {
            font-size: 10px;
            color: #eee;
          }
        }
      }
    }
  }
  .chat-content {
    height: calc(100vh - 7rem);
    min-height: 200px;
    overflow: auto;
    margin-bottom: 52px;
    &::-webkit-scrollbar {
      width: 0;
    }
    .chat-item {
      border-bottom: 1px solid $mainColor;
      padding: 5px 10px;
      &:nth-last-child(2) {
        border: none;
      }
      .t-name {
        color: $mainColor;
        &.t-name-user {
          color: #259292;
        }
      }
      .t-content {
        .t-txt {
          text-indent: 20px;
          margin-bottom: 5px;
        }
        .reply-img {
          margin-right: 6px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .t-time {
        text-align: right;
        font-size: 12px;
      }
    }
  }
  .qs-add {
    position: fixed;
    bottom: 0;
    left: 4%;
    right: 4%;
    padding: 5px 0;
    border-top: 1px solid $mainColor;
    background-color: #f8f8f8;
    .add-txt {
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn {
        display: inline-block;
        padding: 5px 10px;
        font-size: 10px;
        border-radius: 4px;
        &.btn-send {
          background-color: $mainColor;
          border: 1px solid $mainColor;
          margin: 0 4px;
          color: #eee;
        }
        &.btn-solved {
          border: 1px solid #999;
        }
      }
      .box-input {
        flex-grow: 1;
        border: 1px solid #999;
        border-radius: 5px;
        margin-left: 4px;
        .van-cell {
          padding: 5px 10px;
          background-color: transparent;
        }
      }
    }
    .add-img {
      ::v-deep {
        .van-uploader__preview-image {
          width: 60px; height: 60px;
        }
        .van-uploader__upload {
          width: 60px; height: 60px;
        }
      }
    }
  }
}
</style>